/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useVacancyUrl } from 'domain/recruiting/vacancy/vacancyRoute';

const EditVacancyButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useVacancyUrl();

  return <EditButton {...props} path={id => getUpdateEntityUrl(id)} />;
};

export default EditVacancyButton;
